import { FC } from 'react';

type Props = {
	className?: string;
};

const CloudUploadIconDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			className={className}>
			<path
				opacity='0.4'
				d='M14.3997 7.20828C14.3997 4.77381 12.4299 2.80029 9.99984 2.80029C7.69848 2.80029 5.80979 4.57039 5.61626 6.82575C3.58715 7.01919 2 8.73129 2 10.8148C2 12.7535 3.37418 14.3706 5.19993 14.7419L14.7997 14.8C16.5997 14.6007 17.9997 13.0719 17.9997 11.2156C17.9997 9.22368 16.3879 7.609 14.3997 7.609L14.3818 7.60904C14.3937 7.47705 14.3997 7.34337 14.3997 7.20828Z'
				fill='#2B2B2B'
			/>
			<path
				d='M14.3818 7.60904C14.3877 7.60901 14.3937 7.609 14.3997 7.609C16.3879 7.609 17.9997 9.22368 17.9997 11.2156C17.9997 13.0719 16.5997 14.6007 14.7997 14.8M14.3818 7.60904C14.3937 7.47705 14.3997 7.34337 14.3997 7.20828C14.3997 4.77381 12.4299 2.80029 9.99984 2.80029C7.69848 2.80029 5.80979 4.57039 5.61626 6.82575M14.3818 7.60904C14.3 8.51826 13.9426 9.34784 13.394 10.0133M5.61626 6.82575C3.58715 7.01919 2 8.73129 2 10.8148C2 12.7535 3.37418 14.3706 5.19993 14.7419M5.61626 6.82575C5.74253 6.81371 5.87051 6.80755 5.99992 6.80755C6.90056 6.80755 7.73167 7.10576 8.40027 7.609'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.99996 10.8003V17.2002M9.99996 10.8003C9.43981 10.8003 8.39322 12.3957 8 12.8003M9.99996 10.8003C10.5601 10.8003 11.6067 12.3957 11.9999 12.8003'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CloudUploadIconDuotone;
